module.exports = __webpack_public_path__ + "static/media/12 REGGIANA CALCIO Stazione Ferroviaria.803fe644.svg";